import Cookies from 'js-cookie'

const devComponentHost = Cookies.get('devComponentHost')
const devComponentPort = Cookies.get('devComponentPort')

const state = {
    app: {},
    modal: {},
    client: 'MobileSite',
    currentViewName: '',

    metaPages: [], // 被关联的页面列表
    pagesMap: {},
    confMetaMap: {},
    confPagesMap: {},
    dynamicMeta: {},
    appSetting: {},
    viewItems: [],
    componentInfoCache: {}, // 缓存组件基本信息

    confMeta: {},
    confPages: {},
    localComponents: [],

    devComponentHost,
    devComponentPort,
}
export default state
